module.exports = __webpack_public_path__ + "static/media/matilde-cap-china-impressed.2df60d22.png";